import { ThunkDispatch } from 'redux-thunk'
import { RootState } from 'src/redux/createRootReducer'

export const SAVE_SELECTED_VIRTUAL_CARD_IDS =
  'app/virtualCards/virtualCardsAllCards/SAVE_SELECTED_VIRTUAL_CARD_IDS'

export interface SaveSelectedVirtualCardIdsAction {
  type: typeof SAVE_SELECTED_VIRTUAL_CARD_IDS
  payload: {
    selectedVirtualCardIds: string[]
  }
}

export type VirtualCardsAllCardsActions = SaveSelectedVirtualCardIdsAction

export const createSaveSelectedVirtualCardIdsAction = (
  selectedVirtualCardIds: string[],
) => {
  return (
    dispatch: ThunkDispatch<RootState, void, SaveSelectedVirtualCardIdsAction>,
  ): void => {
    dispatch({
      type: SAVE_SELECTED_VIRTUAL_CARD_IDS,
      payload: {
        selectedVirtualCardIds,
      },
    })
  }
}

export const SET_RECEIPT_ATTACHMENT_IDS =
  'app/virtualCards/virtualCardsAllCards/SET_RECEIPT_ATTACHMENT_IDS'
export interface SetReceiptAttachmentIdsAction {
  type: typeof SET_RECEIPT_ATTACHMENT_IDS
  payload: {
    ids: string[]
  }
}
export const createSetReceiptAttachmentIds = (
  ids: string[],
): SetReceiptAttachmentIdsAction => ({
  type: SET_RECEIPT_ATTACHMENT_IDS,
  payload: {
    ids,
  },
})
